import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMentorListApi,
  updateMentorApi,
  createMentorApi,
  deleteMentorApi,
} from "../../apis/teacherManagement";

export const getAllMentors = createAsyncThunk("mentors/getAll", async () => {
  const response = await getMentorListApi();
  return response.data.data;
});

export const createMentor = createAsyncThunk(
  "mentor/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createMentorApi(formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create mentor"
      );
    }
  }
);

export const updateMentor = createAsyncThunk(
  "mentor/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateMentorApi(id, formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update mentor"
      );
    }
  }
);

export const deleteMentor = createAsyncThunk(
  "mentor/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteMentorApi(id);
      return id; // Return deleted subject ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete mentor"
      );
    }
  }
);

const teacherManagementSlice = createSlice({
  name: "teacherManagement",
  initialState: {
    teacherManagement: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.teacherManagement = [];
      state.status = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // get all mentor
      .addCase(getAllMentors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllMentors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.teacherManagement = action.payload;
      })
      .addCase(getAllMentors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // create mentor
      .addCase(createMentor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createMentor.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.teacherManagement.push(action.payload);
      })
      .addCase(createMentor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create mentor.";
      })

      // delete the mentor
      .addCase(deleteMentor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteMentor.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.teacherManagement = state.teacherManagement.filter(
          (mentor) => mentor.id !== action.payload
        );
      })
      .addCase(deleteMentor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete mentor.";
      })

      // update the mentor ---
      .addCase(updateMentor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateMentor.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.teacherManagement = state.teacherManagement.map((mentor) =>
          mentor.id === action.payload.id ? action.payload : mentor
        ); // Update the course in state
      })
      .addCase(updateMentor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update mentor.";
      });
  },
});
export default teacherManagementSlice.reducer;
